@use '../@shared/mixins' as *;
@use '../@shared/global' as *;

@layer kol-component {
	.kol-quote {
		display: inline;
		margin: 0;
		padding: 0;
	}

	.kol-quote__cite {
		&::before {
			content: '—';
		}
	}

	.kol-quote__figcaption {
		.kol-quote--block & {
			display: inline;
			margin: 0;
			padding: 0;
		}
	}

	.kol-quote__blockquote {
		&::before {
			content: open-quote;
		}

		&::after {
			content: close-quote;
		}
	}
}
